import { render, staticRenderFns } from "./RefreshButton.vue?vue&type=template&id=8414074e&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/WebClient/WebClient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8414074e')) {
      api.createRecord('8414074e', component.options)
    } else {
      api.reload('8414074e', component.options)
    }
    module.hot.accept("./RefreshButton.vue?vue&type=template&id=8414074e&", function () {
      api.rerender('8414074e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/RefreshButton.vue"
export default component.exports